import { defineMessages } from 'react-intl';

const messages = defineMessages({
  filterAll: {
    id: 'VRSu1z',
    defaultMessage: 'All',
    description: 'Notification filter label for showing all notifications',
  },
  filterUnread: {
    id: 'o6Wb8u',
    defaultMessage: 'Unread',
    description: 'Notification filter label for showing unread notifications',
  },
});

export { messages };
